import type { SearchResponse } from '@app/shared/schemas/search';
import { apiRequest } from './client';

/**
 * Global search API surface (#search) — centrální vyhledávání v topbaru (⌘K).
 *
 * `GET /api/v1/search?q=…`. Read-only, admin / decision_maker (partner 403).
 * Vrací zgrupované výsledky (zakázky / nabídky / partneři) s malým per-typ limitem.
 */
export function globalSearch(q: string, limit?: number): Promise<SearchResponse> {
  const params: Record<string, unknown> = { q };
  if (limit) params.limit = limit;
  return apiRequest<SearchResponse>({ method: 'GET', url: '/search', params });
}
